import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const FuelCostReferenceRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--fuel-cost-reference']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
